import React from 'react';

type LinkConditionalWrapperProps<T> = {
  children: React.ReactElement;
  wrap?: boolean;
  Component: React.FC<{ href: T; children: React.ReactElement }>;
  href: T;
};

export default function LinkConditionalWrapper<T>({
  wrap,
  children,
  href,
  Component,
}: LinkConditionalWrapperProps<T>) {
  return wrap ? <Component href={href}>{children}</Component> : children;
}
